export default {
    CAP_GROUP: 'capGroup',
    OS: 'os',
    CHANGE: 'change'
};
